<template>
    <div class="personal_information_protection_policy">
      <div class="row flex-center">
        <div class="col-md-12 title">個人情報保護方針</div>
        <div class="col-md-12 news-lists">
            <p>制定日　 2025 年 07 月 18 日</p>
            <p>シュ-電は、個人情報保護の重要性に鑑み、以下の方針に基づき個人情報・個人番号及び特定個人情報(以下、個人番号と特定個人情報を「特定個人情報等」という。)の保護に努めます。</p>
            <p>方針</p>
            <div>
                <p >1. 個人情報保護コンプライアンス・プログラムの策定と継続的改善</p>
                <p>シュ-電は、役員及び従業員に個人情報保護の重要性を認識させ、個人情報・特定個人情報等を適切に保護するための個人情報保護コンプライアンス・プログラム(本方針、「個人情報保護基本規程」及びその他の規程、規則を含む。)を策定、実施、維持し、継続的に改善します。</p>
                <p>2. 「個人情報保護基本規程」の遵守</p>
                <p>シュ-電は、「個人情報保護基本規程」及びその他の規程、規則に従い、各部門の業務内容及び規模を考慮した適切な個人情報・特定個人情報等保護のための管理体制を確立し、個人情報・特定個人情報等を適切に収集、利用、提供するとともに、情報主体(本人)への個人情報・特定個人情報等の開示や訂正等、情報主体への適切な対応を行います。</p>
                <p>3. 個人情報・特定個人情報等の正確性・安全性の確保</p>
                <p>シュ-電は、個人情報・特定個人情報等の正確性及び安全性を確保するため、個人情報・特定個人情報等を正確かつ最新の内容に保つよう努めるとともに、情報通信技術及び管理組織体制の両面から合理的な安全対策を講じて、個人情報・特定個人情報等への不正アクセス、紛失、破壊、改竄、漏洩等の防止に努めます。</p>
                <p>4. 個人情報保護に関する法令及びその他の規範遵守</p>
                <p>シュ-電は、個人情報の保護に関する法令の規定及び行政機関その他が特に定めた規範、ガイドライン等を遵守します。</p>
            </div>
            <p>シュ-電&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;代表取締役社長　宋光輝</p>
            <p ></p>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  export default {
    name: "PersonalInformationProtectionPolicy",
    data() {
      return {

      };
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .personal_information_protection_policy .title{
	font-size: 28px;
	font-weight:bold;
	color:#333;
	margin-top: 60px;
	display: inline-block;
    text-align: center;
  }
  .news-lists{
    max-width: 1200px;
    margin-top: -238px;
    text-align: left;
    background-color: #fff;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 42px 50px;
    font-weight: 400;
  font-size: 22px;
  color: #3D3D3D;
  line-height: 40px;
  }
  .news-lists>div{
  padding: 10px 0 20px 30px;
  }
  .news-lists p{
    font-weight: 400;
  font-size: 18px;
  color: #3D3D3D;
  line-height: 30px;
  padding-bottom: 14px;
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/personalInformationProtectionPolicy.vue